import { fetchIsOnboardingPageViewedApi, processDataWrap, updateIsOnboardingPageViewedApi } from '../utils/api';
import { UPDATE_ON_BOARDING_PAGE_VIEWED } from '../constants/actionTypes';
import { logError } from '@zg-rentals/log-error';

/*
    backend api call is broken out from redux store modification so the user
    does not have to wait for the api call to complete before the onboarding screen is hidden
 */
function updateBackendIsOnboardingPageViewed() {
  return (dispatch, getState) => {
    const { user = {} } = getState();
    const payload = { email: user.email };

    dispatch(updateIsOnboardingPageViewedApi(payload)).then(null, (error) => {
      logError({ context: 'Failed to update isOnboardingPageViewed', error });
    });
  };
}

function updateIsOnboardingPageViewed(payload) {
  return { type: UPDATE_ON_BOARDING_PAGE_VIEWED, payload };
}

const fetchIsOnboardingPageViewed = () => (dispatch) => {
  return dispatch(fetchIsOnboardingPageViewedApi()).then(
    (response = {}) => {
      if (response && response.data) {
        const { isCappsUser } = processDataWrap(response.data);
        dispatch(updateIsOnboardingPageViewed({ isOnboardingPageViewed: isCappsUser }));
      } else {
        logError({ error: 'Failed to fetch isOnboardingPageViewed.' });
      }
    },
    (error) => {
      logError({ context: 'Failed to fetch isOnboardingPageViewed. Error: ', error });
    },
  );
};

export { fetchIsOnboardingPageViewed, updateIsOnboardingPageViewed, updateBackendIsOnboardingPageViewed };
